const creditResume = {
  'credit-resume-current-statement': 'Factura',
  'credit-resume-current-statement-due-date': 'Fecha de vencimiento ',
  'credit-resume-next-statement': 'Próxima factura',
  'credit-resume-next-statement-due-date': 'Fecha de vencimiento ',
  'credit-resume-transfer': 'Transfer',
};

export default creditResume;
